goog.provide("shadow.js.shim.module$$mui$material$Box");
goog.provide("module$shadow_js_shim_module$$mui$material$Box");
shadow.js.shim.module$$mui$material$Box = shadow.js.nativeProvides["@mui/material/Box"] = shadow$bridge("@mui/material/Box");
module$shadow_js_shim_module$$mui$material$Box.default = shadow.js.shim.module$$mui$material$Box;
